// The standalone language picker for surfaces with no account menu behind them
// — the auth layout and the landing page. Signed in, the same choice lives in
// the account menu's Language row instead; both read `@/lib/languages`, so the
// two can never offer different sets.
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { FlagImage } from 'react-international-phone';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { LANGUAGES, resolveLanguage } from '@/lib/languages';

function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const activeLang = resolveLanguage(i18n.language);

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm" aria-label={activeLang.label}>
                    <Languages className="size-4.5" />
                    <FlagImage
                        iso2={activeLang.iso2}
                        style={{ width: '20px', height: '15px', flexShrink: 0 }}
                    />
                    <span className="uppercase">{activeLang.code}</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {LANGUAGES.map((lang) => (
                    <DropdownMenuItem
                        key={lang.code}
                        onClick={() => void i18n.changeLanguage(lang.code)}
                        // Resolved code on both sides: comparing the raw tag left
                        // every row unhighlighted on a browser-supplied `en-US`.
                        className={lang.code === activeLang.code ? 'bg-accent' : ''}
                        lang={lang.code}
                    >
                        <FlagImage
                            iso2={lang.iso2}
                            style={{ width: '20px', height: '15px', flexShrink: 0 }}
                        />
                        <span>{lang.nativeLabel}</span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export { LanguageSwitcher };
